import { type IdentityRefFragment } from '@spotify/confidence-graphql';
import {
  IdentityInline,
  useCurrentIdentity,
} from '@spotify/plugin-confidence-iam-react';

import { useChatContext } from '../ChatThread/ChatContext';

import styles from './UserMessageAuthor.module.css';

interface UserMessageAuthorProps {
  author: IdentityRefFragment;
}

export const UserMessageAuthor = ({ author }: UserMessageAuthorProps) => {
  const isChildTranscript = useChatContext()?.isChildTranscript ?? false;
  const { currentIdentity, isLoading } = useCurrentIdentity({
    skip: isChildTranscript,
  });

  if (isChildTranscript || isLoading || currentIdentity?.name === author.name) {
    return null;
  }

  return (
    <div className={styles.author}>
      <IdentityInline identityRef={author} />
    </div>
  );
};
